import { css } from '@emotion/react';
import { APP_NAME } from '@anytag/shared-constants';
import { Anchor, AnchorProps, Loading } from '@anytag/shared-atoms';
import { anyTagBlackImage, anyTagWhileImage } from '@anytag/shared-assets';
import { cn } from '@anytag/shared-utils';
import { useCustomLogo } from './use-custom-logo';

export interface LogoProps extends AnchorProps {
  type?: 'white' | 'black';
}

export const Logo = ({ type = 'white', className, ...restProps }: LogoProps) => {
  const { customLogo, loading } = useCustomLogo();

  const defaultLogo = (() => {
    switch (type) {
      case 'black':
        return anyTagBlackImage;
      default:
        return anyTagWhileImage;
    }
  })();

  return (
    <Anchor className={cn('block h-[29px] w-[max-content] flex-none', className)} {...restProps}>
      {loading ? (
        <div css={{ height: 'inherit', aspectRatio: '1/1' }}>
          <Loading thickness={0.9} css={styles.loading} />
        </div>
      ) : (
        <img
          className="h-[inherit] w-[inherit]"
          src={customLogo.url || defaultLogo}
          alt={customLogo.alt || `${APP_NAME} Influencer Marketing Platform`}
        />
      )}
    </Anchor>
  );
};

const styles = {
  wrapper: css({
    flex: 'none',
    height: '29px',
    display: 'block',
    width: 'max-content'
  }),
  loading: css({
    width: '100%',
    height: '100%',
    '& > span': { width: '100%', height: '100%' }
  })
};
